import type { OidcAccessToken } from '@ori/auth';

import { getPublicToken } from './getPublicToken';
import { getToken } from './getToken';
import type { TokenConfiguration } from '~/models';

export const getAuthorizationToken = async (
  tokenConfiguration: TokenConfiguration,
  isCustomerAnonymous: boolean,
) => {
  let token: OidcAccessToken | undefined;

  if (!isCustomerAnonymous) {
    token = await getToken(tokenConfiguration);
  }

  if (!token) {
    token = await getPublicToken();
  }

  if (!token) {
    throw new Error('Missing access token');
  }

  return token;
};
